export default function ImagesConfiguration($translatePartialLoaderProvider) {
    $translatePartialLoaderProvider.addPart('images');
}

ImagesConfiguration.$inject = ['$translatePartialLoaderProvider'];
